import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar } from '@alefeducation/ui-elements-library-core';
import { rtl } from '../../../utils/language';

const AvatarRenderer = props => (
  <Container className={props.className} data-testid="student-avatar">
    <Avatar src={props.src} size={props.size} />
  </Container>
);

AvatarRenderer.defaultProps = {
  className: '',
  size: undefined,
};

AvatarRenderer.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.number,
};

export default AvatarRenderer;

const Container = styled.div`
  vertical-align: middle;

  ${rtl`
    margin-right: 0;
    margin-left: 10px;
  `};
`;
